import React, {Component} from 'react';
import axios from "axios";
import $ from 'jquery';
import StaticHeader from "../../StaticHeader";
import {Link, NavLink, Redirect} from "react-router-dom";
import * as _ from "lodash";
import {getCDNUrl} from "../../commons/CommonFunctions";
import ReadMoreReadLess from "../../commons/ReadMoreReadLess";
import HorizontalScroll from "react-scroll-horizontal";
import mappingUtils from "../../project/component/commons/utils/mappingUtils";
import CircleIntro from "../intro/CircleIntro";
import PrivateProfile from "../../profile/container/profile/PrivateProfile";
import AuthModalComponent from '../../LoginExtra/AuthModalComponent';
import SignUpModal from "../../SignUpModal/signUpModal";
import LeftPanelUnauth from "../../commons/LeftPanelUnauth";
import Header from "../../Header";
import NotFound from "../../404";
import { getUserPostCount } from '../../services/StudioApi';
import { pageClickHookPostMethod } from '../../services/PostApi';

class UnAuthAboutCircle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            circleData:{},
            circleIntro:[],
            circleLocation:{},
            keyMembersList: [],
            circleList: [],
            sharingConfig:{},
            notFoundstatusCode: false,
            userPostCountData: {}
        }
    }

    componentDidMount() {
        window.$(".unauthLoginPopclose").click(function(){
            window.$(".bkbackdrop2").hide();
        });

        window.$('#header .iCross').hide();
        window.$("#header .iHamburger").on('click', function (event) {
            window.$('.leftpanel').addClass('navactive');
            window.$('.dgcontainer').addClass('navactive');
            window.$('.staticPage').addClass('navactive');
            window.$('#header .iHamburger').hide();            
            window.$('#header .iCross').show();
        });
        $("body, html").on('click', function (event) {
            if (!$(event.target).closest('#header .iHamburger, .read-more-less-btn').length) {
                $('.leftpanel').removeClass('navactive');
                $('.dgcontainer').removeClass('navactive');
                window.$('.staticPage').removeClass('navactive');
                $('.dropdown-menu.show').removeClass('show');
                window.$('#header .iHamburger').show();            
                window.$('#header .iCross').hide();
            }
        });
        window.$('.usermenu .dropdown-submenu > a').on("click", function (e) {
            var submenu = $(this);
            $('.usermenu .dropdown-submenu .dropdown-menu').removeClass('show');
            submenu.next('.usermenu .dropdown-menu').addClass('show');
            e.stopPropagation();
        });

        this.getCircleData()
        this.getCircleLocation();
        this.getKeyMembersList();
    }

    getUserPostCount = async (id) => {
        let response = await getUserPostCount({"userId": id});
        if(response?.message === "Success!") {
            this.setState({
                userPostCountData: response.body
            })
        }
    }

    getSharingConfig = (id) => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/unauth/get/sharing-config-circle?userId=' + id,
            headers: {'Content-Type': 'application/json'},

            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res.status === '200 OK') {
                this.setState({'sharingConfig': res.body})
            }

        }).catch((err) => {
            if (err && err.response) {
                this.setState({
                    error: {message: err.response.data.message, err: err.response}
                })
            }
        });
    };

    getKeyMembersList = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/unauth/get/key/member/list/' + this.props.match.params.slug + '?page=0&size=5',
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res && res.status === '200 OK') {
                this.setState({
                    keyMembersList: res.body.content
                })
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    getCirclePostList = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/backend/unauth/get/intro/post/list/' + this.state.circleData.id,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res && res.status === '200 OK') {
                this.setState({
                    circleList: res.body.content
                }, () => {
                    this.setState({
                        displayImage: true,
                        isCirclePostList: response.data.message
                    })
                })
            }
        }).catch((err) => {
            console.log(err)
        });
    }


    getCircleData = () =>{
        axios({
            method: "get",
            url: process.env.REACT_APP_userServiceURL + '/unauth/getCircleData?slug=' + this.props.match.params.slug,
            headers: {"Content-Type": "application/json"},
            withCredentials: true,
        }).then((response)=>{
            let res = response.data;
            if (res && res.status === '200 OK') {
                this.setState({
                    circleData:res.body
                },()=>{
                    this.handlePageClickHookPost(this.state.circleData.id);
                    this.getUserPostCount(this.state.circleData.id);
                    this.getCirclePostList();
                    this.getSharingConfig(this.state.circleData.id);
                })
            }
        }).catch((err)=>{
            if (err.response && err.response.status === 404 || err.response.status === 410) {
                this.setState({notFoundstatusCode: true})
            }
        })
    }

    handlePageClickHookPost = async (entityId) => {
        let postData = {
          entityId: entityId,
          userId: null,
          entityType: "CIRCLE"
        }
        await pageClickHookPostMethod(postData);
    }

    getCircleLocation = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/backend/unauth/getCircleLocation?slug=' + this.props.match.params.slug,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res && res.status === '200 OK') {
                this.setState({
                    circleLocation: res.body
                })
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    getCoverOptimizedImage(circleInfo) {
        if (circleInfo.resizedCoverImages && circleInfo.resizedCoverImages['compressed'] != null) {
            return circleInfo.resizedCoverImages['compressed'];
        }
        return circleInfo.coverImage;
    }

    getOptimizedImage(circleInfo) {
        if (circleInfo.resizedProfileImages && circleInfo.resizedProfileImages['compressed'] != null) {
            return circleInfo.resizedProfileImages['compressed'];
        }
        return circleInfo.profileImage;
    }

    getOptimizedProfileImage(data) {
        if (data.resizedProfileImages && data.resizedProfileImages['200x200'] != null) {
            return data.resizedProfileImages['200x200'];
        }
        return data.originalProfileImage;
    }

    loginRequired() {
        this.setState({'loginRequired': true})
        window.$('#loginModal').modal('show');
    }
    handleLoginClose = () => {
        this.setState({'loginRequired': false})
        window.$('#loginModal').modal('hide');
    }

    signUpRequired=()=>{
        this.setState({'signUpRequired':true})
        window.$('#signupModal').modal('show');
    }

    handleSignUpClose = () => {
        this.setState({'signUpRequired': false})
        window.$('#signupModal').modal('hide');
    }


    render() {
        const { userPostCountData } = this.state;
        const parent  = { height: `19px`}
        if(this.state.notFoundstatusCode){
            return <><StaticHeader />
            <main className="dgcontainer hm3col">
               <div className="container">
                   <NotFound/>
               </div>
            </main></>
        }else {
            return (
                this.state.circleData && this.state.circleData.deactivated ? <Redirect to={"/community/unavailable"} /> :
                    <div className="staticPage">
                        <div className={(window.location.href.indexOf('/community/activity/') !== -1 || window.location.href.indexOf('/community/projects/') !== -1 || window.location.href.indexOf('/community/members/') !== -1) ? "wrapper projectpage profilepage ppersonal" : "wrapper projectpage profilepage pabout ppersonal unauthProfilePg"}>
                            <div className="wrapper projectpage nologinpage">

                                {this.state.circleData.unauthPageShow === false ? <PrivateProfile /> :
                                    this.state.circleData.unauthPageShow ?
                                        <><StaticHeader />
                                            <main className="dgcontainer hm3col">
                                                <div className="container">
                                                    <div className="row">

                                                        <div className="col-md-9">
                                                            <div className="projectinn microcommfeed">
                                                                <div className="profbannwrap">
                                                                    <img
                                                                        src={this.state.circleData && this.state.circleData.coverImage && !_.isNull(this.state.circleData.coverImage) ? getCDNUrl(this.getCoverOptimizedImage(this.state.circleData)) : 'https://cdn.dscovr.com/images/prof-banner.webp'}
                                                                        onError={(e) => {
                                                                            e.target.onerror = null;
                                                                            e.target.src = "https://cdn.dscovr.com/images/prof-banner.png"
                                                                        }} id="preview" />
                                                                    <div className="microcommaboutdesc">
                                                                        <div className="microcommaboutinn">
                                                                            <figure className="userbannico">
                                                                                <img
                                                                                    src={(this.state.circleData && this.state.circleData.profileImage) ? getCDNUrl(this.getOptimizedImage(this.state.circleData, 'profileImage')) : "https://cdn.dscovr.com/images/circleDefault.webp"}
                                                                                    onError={(e) => {
                                                                                        e.target.onerror = null;
                                                                                        e.target.src = "https://cdn.dscovr.com/images/circleDefault.png"
                                                                                    }} alt="" />
                                                                            </figure>
                                                                            <div>

                                                                                <h1 className="h1ttl">{this.state.circleData && this.state.circleData.title}</h1>
                                                                                <div className="category">
                                                                                    <span> {mappingUtils.getFormattedDate(this.state.circleData && this.state.circleData.incorporationDate)}</span>
                                                                                </div>
                                                                                <span className="date"><i
                                                                                    className="iLocation" /> {this.state.circleLocation && this.state.circleLocation.country ? this.state.circleLocation.city + ', ' + this.state.circleLocation.state + ', ' + this.state.circleLocation.country : null}</span>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="projtopbar" style={{ marginBottom: '0px' }}>
                                                                    <div className="proftopuserinfo about">
                                                                        <div className="proftopusersm">
                                                                            <figure className="userlogo">
                                                                                <img
                                                                                    src={(this.state.circleData && this.state.circleData.profileImage) ? getCDNUrl(this.getOptimizedImage(this.state.circleData, 'profileImage')) : "https://cdn.dscovr.com/images/circleDefault.webp"}
                                                                                    onError={(e) => {
                                                                                        e.target.onerror = null;
                                                                                        e.target.src = "https://cdn.dscovr.com/images/circleDefault.png"
                                                                                    }} alt="" />
                                                                            </figure>
                                                                            <h1><strong>{this.state.circleData && this.state.circleData.title}</strong></h1>
                                                                        </div>
                                                                    </div>
                                                                    <div className="projtopbarleft">
                                                                        <div className="mcustHorizMenu">
                                                                            <div className="mcustHorizinn">
                                                                                <ul id="tabs" className="nav">
                                                                                    <li className="nav-item"><a href="javascript:void(0);" className="active">About</a></li>
                                                                                    {userPostCountData?.myPost > 0 && <li className="nav-item"><Link to={`/community/studio/${this.props.match.params.slug}`}>Studio</Link></li>}
                                                                                    {userPostCountData?.articleCount > 0 && this.state.circleData?.activityTabShow && <li className="nav-item"><Link to={`/community/article/${this.props.match.params.slug}`}>Articles</Link></li>}
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="profuserinfowrap">
                                                                    <div className="profuserdescwrap">
                                                                        <div className="profuserdesctop">
                                                                            <div className="profuserdesccont">
                                                                                <h3 className="title">Who we are</h3>
                                                                                <div className="feeddescwrap">
                                                                                    {this.state.circleData && this.state.circleData.description && this.state.circleData.description !== '' ? <ReadMoreReadLess key={this.state.circleData.id} id={this.state.circleData.id} description={this.state.circleData.description} /> : ''}
                                                                                </div>
                                                                                {this.state.circleData && mappingUtils.getSharingSettingDataForUnAuth(this.state.sharingConfig, 'specialization') && this.state.circleData.specializations && this.state.circleData.specializations.length > 0 &&
                                                                                    <div className="profuserdescnav">
                                                                                        <HorizontalScroll style={parent} reverseScroll>
                                                                                            <ul>
                                                                                                <li className="title">Our Specialization:</li>
                                                                                                {this.state.circleData && this.state.circleData.specializations && this.state.circleData.specializations.map((data) => {
                                                                                                    return <li>{data}</li>
                                                                                                })
                                                                                                }
                                                                                            </ul>
                                                                                        </HorizontalScroll>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {this.state.circleData && !this.state.circleData.active ?
                                                                    <div className="zdata znetwfollow1">
                                                                        <div className="imgbox circle-Zdata-img-bx">
                                                                            <img src="https://cdn.dscovr.com/images/CirclesFillerImg.svg" alt="" />
                                                                        </div>
                                                                        <div className="desc circle-z-desc">
                                                                            <h4>Community is a great way to interact with people<br/> who share the same interests or causes.
                                                                                <br/>Share your ideas, work and stories with your community members to create a larger impact together.
                                                                            </h4>
                                                                        </div>
                                                                    </div> : <>


                                                                        {mappingUtils.getSharingSettingDataForUnAuth(this.state.sharingConfig, 'key_member') &&
                                                                            <div className="circleKeyMemb">
                                                                                <h3>Key Members</h3>
                                                                                <div className="circleKeyMembrow">
                                                                                    {this.state.keyMembersList && this.state.keyMembersList.map((member) => {
                                                                                        return <div className="ckeyMemb">
                                                                                            <figure className="users" onClick={(e) => {
                                                                                                this.redirectToProfile(member.customUrl)
                                                                                            }}><img
                                                                                                    src={member.originalProfileImage ? getCDNUrl(this.getOptimizedProfileImage(member)) : mappingUtils.returnDefaultImage(member.userType)}
                                                                                                    alt="" /></figure>
                                                                                            <div className="infoblk">
                                                                                                <h5 onClick={(e) => {
                                                                                                    this.redirectToProfile(member.customUrl)
                                                                                                }}>{member.username}</h5>
                                                                                                <span className="persona"><strong>{member.type}</strong></span>
                                                                                                <span className="country">{member.country}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    })}
                                                                                </div>
                                                                            </div>}

                                                                        {mappingUtils.getSharingSettingDataForUnAuth(this.state.sharingConfig, 'what_we_do') &&
                                                                            <CircleIntro circleData={this.state.circleData}
                                                                                circleList={this.state.circleList}
                                                                                getCirclePostList={this.getCirclePostList}
                                                                                displayImage={this.state.displayImage}
                                                                                isCirclePostList={this.state.isCirclePostList} />
                                                                        }

                                                                        {mappingUtils.getSharingSettingDataForUnAuth(this.state.sharingConfig, 'interests') &&
                                                                            <div className="circlrInterestHash">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <div className="circlrInterestHashBlk">
                                                                                            <h2 className="title">Our Interests</h2>
                                                                                            <div className="cirInterestblk">
                                                                                                {this.state.circleData && this.state.circleData.interests && this.state.circleData.interests.length === 0 ?
                                                                                                    <p>No interests updated</p> :
                                                                                                    this.state.circleData && this.state.circleData.interests && this.state.circleData.interests.map((data) => {
                                                                                                        return <span>{data}</span>
                                                                                                    })
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>}</>}
                                                                {/*  */}
                                                                <div className="bkbackdrop2">
                                                                    <div className="unauthLoginPop">
                                                                        {/* <button className="unauthLoginPopclose"><i className="iCross"/></button>
                                                <div className="unauthLoginPopImgbx">
                                                    <Link to="/login"><img src="https://cdn.dscovr.com/images/welock.png" alt="" className="img-fluid" /></Link>
                                                </div> */}
                                                                        <div className="unauthLoginPopdesc">
                                                                            {/* <h5><Link to="/login">Explore More</Link></h5> */}
                                                                            <a href="javascript:void(0)" onClick={this.loginRequired.bind(this)} className="bkloginBtn"><i className="iArrow-Up" />You must <span>login</span> to explore more</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/*  */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </main></> : null}
                                <LeftPanelUnauth signUpRequired={this.signUpRequired} />
                                {this.state.loginRequired === true ? <AuthModalComponent handleLoginClose={this.handleLoginClose} pathname={this.state.pathname} history={this.props.history} /> : null}
                                {this.state.signUpRequired === true ? <SignUpModal handleSignUpClose={this.handleSignUpClose} history={this.props.history} /> : null}
                            </div>
                        </div>
                    </div>
            );
        }
    }
}

export default UnAuthAboutCircle;